import * as React from "react";
import type { SVGProps } from "react";
const SvgCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="circle_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448L485.247 690.816a43.093 43.093 0 0 1-60.587 1.11l-134.1-127.703a42.667 42.667 0 1 1 58.88-61.781l103.85 98.901 220.16-225.792a42.667 42.667 0 1 1 61.1 59.563z"
    />
  </svg>
);
export default SvgCircleIcon;
